import { render, staticRenderFns } from "./dataTablePart.vue?vue&type=template&id=18bc19b2&"
import script from "./dataTablePart.vue?vue&type=script&lang=js&"
export * from "./dataTablePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports